
(function(){
  var K='zv-tt-hide', wrap=document.getElementById('zvtt');
  if(!wrap) return;
  var pill=document.getElementById('zvttOpen'), panel=document.getElementById('zvttPanel'), x=document.getElementById('zvttClose');

  function get(k){try{return localStorage.getItem(k)}catch(e){return null}}
  function set(k,v){try{localStorage.setItem(k,v)}catch(e){}}

  var until=parseInt(get(K)||'0',10);
  if(until && Date.now() < until) return;

  var shown=false;
  function show(){
    if(shown) return; shown=true;
    wrap.classList.add('in');
    window.removeEventListener('scroll',onScroll);
  }
  function onScroll(){
    var h=document.documentElement.scrollHeight-window.innerHeight;
    if(h>0 && (window.scrollY/h)>0.33) show();
  }
  window.addEventListener('scroll',onScroll,{passive:true});
  setTimeout(show,7000);

  pill.addEventListener('click',function(){
    wrap.classList.add('open');
    pill.setAttribute('aria-expanded','true');
    x.focus();
  });
  function collapse(remember){
    wrap.classList.remove('open');
    pill.setAttribute('aria-expanded','false');
    if(remember){
      wrap.classList.remove('in');
      set(K, String(Date.now() + 14*24*60*60*1000));
    }
  }
  x.addEventListener('click',function(){ collapse(true); });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape' && wrap.classList.contains('open')){ collapse(false); pill.focus(); }
  });
  document.addEventListener('click',function(e){
    if(!wrap.classList.contains('open')) return;
    if(!wrap.contains(e.target)) collapse(false);
  });
})();
